import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('components.TwoFaEnablingWizard.StepperTwoFaWizard', {
    step1: 'Download the app',
    step2: 'Enter the code',
    step3: 'Backup method',
});
